<template>
  <div class="start">
    <div class="question">{{ $t('promotion_new.start_date') }}</div>
    <datetime type="datetime" v-model="promotion.startAt" :use12-hour="true"/>
  </div>
</template>

<script>
export default {
  name: "PromotionStart",

  props: {
    promotion: Object
  }
}
</script>